export default {
  Title: 'Tham số báo cáo',
  Year: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  DecisionNoLabel: 'Kèm theo quyết định',
  DecisionDateLabel: 'Ngày',
  ViewReport: 'Xem báo cáo',
  Cancel: 'Hủy',
};
